import { render, staticRenderFns } from "./JobApprovalComments.vue?vue&type=template&id=4ea61f0f&scoped=true"
import script from "./JobApprovalComments.vue?vue&type=script&lang=js"
export * from "./JobApprovalComments.vue?vue&type=script&lang=js"
import style0 from "./JobApprovalComments.vue?vue&type=style&index=0&id=4ea61f0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea61f0f",
  null
  
)

export default component.exports